const ChargeTypeEnum = {
    boleto: 1,
    cartao: 2,
};

export default ChargeTypeEnum;